import type { InputDescriptor } from "../../lib/types";

export interface CustomerPortalInputs {
  csrHeadCount: number;
  annualCsrSalary: number;
  dailyInteractionsPerCsr: number;
  minutesPerInteraction: number;
  selfServiceTransactionPercent: number;
  implementationFee: number;
  monthlyPrice: number;
}

export const CUSTOMER_PORTAL_DEFAULTS: CustomerPortalInputs = {
  csrHeadCount: 4,
  annualCsrSalary: 50000,
  dailyInteractionsPerCsr: 30,
  minutesPerInteraction: 5,
  selfServiceTransactionPercent: 25,
  implementationFee: 2500,
  monthlyPrice: 500
};

export const CUSTOMER_PORTAL_FIELDS: InputDescriptor<keyof CustomerPortalInputs>[] = [
  {
    key: "csrHeadCount",
    label: "Total number of customer service reps interacting with customers?",
    kind: "number",
    step: "1"
  },
  {
    key: "annualCsrSalary",
    label: "Average annual CSR salary including benefits?",
    kind: "currency",
    step: "100"
  },
  {
    key: "dailyInteractionsPerCsr",
    label: "Total number of customer interactions (calls, emails, etc) per CSR per day?",
    kind: "number",
    step: "1"
  },
  {
    key: "minutesPerInteraction",
    label: "Minutes per customer interaction?",
    kind: "minutes",
    step: "1"
  },
  {
    key: "selfServiceTransactionPercent",
    label: "Estimated percentage of customer interactions that could be self served through a customer portal?",
    kind: "percent",
    step: "1"
  },
  {
    key: "implementationFee",
    label: "Customer Portal one-time implementation fee?",
    kind: "currency",
    step: "100"
  },
  {
    key: "monthlyPrice",
    label: "Customer Portal flat monthly price?",
    kind: "currency",
    step: "10"
  }
];
